export const LOGIN = 'LOGIN';
export const SET_EMAIL = 'SET_EMAIL';
